import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { ListContainer } from 'components';
import DistributorDetails from './distributor-details/DistributorDetails';
import DistributorInvite from './DistributorInvite';
import DistributorsTable from './DistributorsTable';

const Distributors = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={`${path}/details/:id`} component={DistributorDetails} />
                <Route path={`${path}/create`} component={DistributorInvite} />
                <Route path={`${path}/edit/:id?`} component={DistributorInvite} />
                <Route path={path} render={() => <DistributorsTable />} />
            </Switch>
        </ListContainer>
    );
};

export default Distributors;
